/* eslint-disable */
export const selectCustomField = state => state.userCustomfield;
